Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.isMQTTMessageOutdated=exports.updateRamDevice=exports.default=exports.unhealthyReason=exports.actions=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _reduxOrm=require('redux-orm');
var _utils=require('./utils');
var _MQTTActionTypes=require('../actions/MQTTActionTypes');var _MQTTActionTypes2=_interopRequireDefault(_MQTTActionTypes);
var _types=require('../exceptions/types');



var _securityDeviceArmState=require('../armState/securityDeviceArmState');
var _securityDeviceException=require('../exceptions/securityDeviceException');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_SECURITY_DEVICES:'UPSERT_SECURITY_DEVICES',
UPDATE_SECURITY_DEVICES:'UPDATE_SECURITY_DEVICES',
UPDATE_SECURITY_DEVICE:'UPDATE_SECURITY_DEVICE'};


var unhealthyReason=exports.unhealthyReason={
LOCK_STUCK:'lock_stuck',
LOCK_STUCK_UNLOCKED:'lock_stuck_unlocked',
LOST_COMM:'lost_communication'};var





SecurityDevice=function(_Model){_inherits(SecurityDevice,_Model);function SecurityDevice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SecurityDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SecurityDevice.__proto__||Object.getPrototypeOf(SecurityDevice)).call.apply(_ref,[this].concat(args))),_this),_this.
















































































































































































































































































































































































































































































































hasHealthExceptions=function(){return(
_types.SECURITY_DEVICE_HEALTH_EXCEPTIONS.includes(
(0,_securityDeviceException.getSecurityDeviceHealthException)(_this)));},_this.


hasSecurityExceptions=function(){return(
_types.SECURITY_DEVICE_SECURITY_EXCEPTIONS.includes(
(0,_securityDeviceArmState.getSecurityDeviceArmState)(_this).type));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SecurityDevice,[{key:'getArmDevice',value:function getArmDevice(){if(!this.deviceType){return this;}switch(this.deviceType){case'dumb_puck':return this.parentId||this;case'base':case'base_v2':case'proximity_base':case'di_riser':return this.children.first()||this;default:return this;}}},{key:'isLock',value:function isLock(){return this.deviceType==='lock';}},{key:'isSecurePlug',value:function isSecurePlug(){return this.deviceType==='secure_plug';}},{key:'getUnlockedTime',value:function getUnlockedTime(){var unlockedTimeSeconds=this._getUnlockedTimeSeconds();if(unlockedTimeSeconds>0){var unlockedTimeMinutes=Math.floor(unlockedTimeSeconds/60);return Math.min(SecurityDevice.lockMaxTimeThreshhold,Math.max(0,unlockedTimeMinutes));}return-1;}},{key:'hasExceededUnlockTimeThreshold',value:function hasExceededUnlockTimeThreshold(){return this.getUnlockedTime()>=SecurityDevice.lockMaxTimeThreshhold;}},{key:'_getUnlockedTimeSeconds',value:function _getUnlockedTimeSeconds(){var securityStatusUpdatedAt=this.securityStatusUpdatedAt;if(securityStatusUpdatedAt){var now=Date.now();return Math.floor((now-new Date(this.securityStatusUpdatedAt))/1000);}return-1;}},{key:'toString',value:function toString(){return'Security Device: '+this.id;}}],[{key:'reducer',value:function reducer(action,SecurityDevice,session){if(!action)return undefined;var payload=action.payload;var nanos=void 0;var seconds=void 0;if(payload){var metadata=payload.metadata;if(metadata){var messageSentAt=metadata.messageSentAt;if(messageSentAt){nanos=messageSentAt.nanos;seconds=messageSentAt.seconds;}}}switch(action.type){case actions.UPSERT_SECURITY_DEVICES:{var devices=action.payload.devices;devices.forEach(function(d){SecurityDevice.upsert(d);});break;}case actions.UPDATE_SECURITY_DEVICES:{var _devices=action.payload.devices;var devicesToRemove=SecurityDevice.exclude(function(device){return _devices.find(function(_ref2){var id=_ref2.id;return device.id===id;});});devicesToRemove.delete();_devices.forEach(function(device){return SecurityDevice.upsert(device);});break;}case actions.UPDATE_SECURITY_DEVICE:{var device=action.payload.device;SecurityDevice.upsert(device);break;}case _MQTTActionTypes2.default.UPDATE_PUCK_STATE:case _MQTTActionTypes2.default.UPDATE_PROXIMITY_PUCK_STATE:var puckState=action.payload;var serialNumber=puckState.serialNumber;try{var _device=SecurityDevice.get({serialNumber:serialNumber});var _device$messageSentAt=_device.messageSentAt;_device$messageSentAt=_device$messageSentAt===undefined?{}:_device$messageSentAt;var oldNanos=_device$messageSentAt.nanos,oldSeconds=_device$messageSentAt.seconds;if(isMQTTMessageOutdated(oldNanos,oldSeconds,nanos,seconds)){break;}if(_device.securityStatusUpdatedAt>puckState.stateUpdatedAt){break;}var liftCount=_device.liftCount;if(liftCount&&!_device.lifted&&puckState.lifted){liftCount+=1;}var input=(0,_utils.filterInput)(SecurityDevice)({identifying:puckState.identifying,armed:puckState.armed,silentAlarming:puckState.silentAlarming,alarming:puckState.tetherAlarming||puckState.smartCableAlarming||puckState.puckAlarming||puckState.alarming,lifted:puckState.lifted,liftCount:liftCount,securityStatusUpdatedAt:puckState.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos}});_device.update(input);}catch(e){}break;case _MQTTActionTypes2.default.UPDATE_RAM_STATE:updateRamDevice(action,seconds,nanos,SecurityDevice);break;case _MQTTActionTypes2.default.UPDATE_SECURE_PLUG_STATE:updateRamDevice(action,seconds,nanos,SecurityDevice);var securePlugState=action.payload;try{var _serialNumber=securePlugState.serialNumber;var _device2=SecurityDevice.get({serialNumber:_serialNumber});var _device2$messageSentA=_device2.messageSentAt;_device2$messageSentA=_device2$messageSentA===undefined?{}:_device2$messageSentA;var _oldNanos=_device2$messageSentA.nanos,_oldSeconds=_device2$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos,_oldSeconds,nanos,seconds)){break;}if(_device2.securityStatusUpdatedAt>securePlugState.stateUpdatedAt){break;}var _input=(0,_utils.filterInput)(SecurityDevice)({securityStatusUpdatedAt:securePlugState.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos},batteryLevel:securePlugState.batteryLevel,charging:securePlugState.charging,powered:securePlugState.powered,identifying:securePlugState.identifying,armed:securePlugState.armed,silentAlarming:securePlugState.silentAlarming,powerOutEnabled:securePlugState.powerOutEnabled,ovcPending:securePlugState.ovcPending,deepSleep:securePlugState.deepSleep,firmwareVersion:securePlugState.firmwareVersion,hardwareVersion:securePlugState.hardwareVersion,model:securePlugState.model,alarming:securePlugState.socketAlarming||securePlugState.ovcAlarming||securePlugState.lopAlarming||securePlugState.port1.socketFault||securePlugState.port2.socketFault||securePlugState.port3.socketFault||securePlugState.port4.socketFault||securePlugState.port5.socketFault||securePlugState.port6.socketFault,ports:[_extends({},_device2.ports[0],securePlugState.port1),_extends({},_device2.ports[1],securePlugState.port2),_extends({},_device2.ports[2],securePlugState.port3),_extends({},_device2.ports[3],securePlugState.port4),_extends({},_device2.ports[4],securePlugState.port5),_extends({},_device2.ports[5],securePlugState.port6)]});_device2.update(_input);}catch(e){console.warn(e);}break;case _MQTTActionTypes2.default.UPDATE_CX_FLEX_STATE:updateRamDevice(action,seconds,nanos,SecurityDevice);var cxFlexState=action.payload;try{var _serialNumber2=cxFlexState.serialNumber;var _device3=SecurityDevice.get({serialNumber:_serialNumber2});var _device3$messageSentA=_device3.messageSentAt;_device3$messageSentA=_device3$messageSentA===undefined?{}:_device3$messageSentA;var _oldNanos2=_device3$messageSentA.nanos,_oldSeconds2=_device3$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos2,_oldSeconds2,nanos,seconds)){break;}if(_device3.securityStatusUpdatedAt>cxFlexState.stateUpdatedAt){break;}var isAlarming=function isAlarming(port){return port.primaryDeviceAlarming||port.secondaryDeviceAlarming;};var _input2=(0,_utils.filterInput)(SecurityDevice)({securityStatusUpdatedAt:cxFlexState.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos},batteryLevel:cxFlexState.batteryLevel,charging:cxFlexState.charging,powered:cxFlexState.powered,deepSleep:cxFlexState.deepSleep,silentAlarming:cxFlexState.silentAlarming,identifying:cxFlexState.identifying,armed:cxFlexState.armed,baseLifted:cxFlexState.baseLifted,baseLiftAlarming:cxFlexState.baseLiftAlarming,lostCommunication:cxFlexState.lostCommunication,firmwareVersion:cxFlexState.firmwareVersion,hardwareVersion:cxFlexState.hardwareVersion,model:cxFlexState.model,alarming:cxFlexState.baseLiftAlarming||isAlarming(cxFlexState.port1)||isAlarming(cxFlexState.port2)||isAlarming(cxFlexState.port3)||isAlarming(cxFlexState.port4)||isAlarming(cxFlexState.port5)||isAlarming(cxFlexState.port6)||isAlarming(cxFlexState.port7)||isAlarming(cxFlexState.port8)||isAlarming(cxFlexState.port9)||isAlarming(cxFlexState.port10),ports:[_extends({},_device3.ports[0],cxFlexState.port1),_extends({},_device3.ports[1],cxFlexState.port2),_extends({},_device3.ports[2],cxFlexState.port3),_extends({},_device3.ports[3],cxFlexState.port4),_extends({},_device3.ports[4],cxFlexState.port5),_extends({},_device3.ports[5],cxFlexState.port6),_extends({},_device3.ports[6],cxFlexState.port7),_extends({},_device3.ports[7],cxFlexState.port8),_extends({},_device3.ports[8],cxFlexState.port9),_extends({},_device3.ports[9],cxFlexState.port10)]});_device3.update(_input2);}catch(e){console.warn(e);}break;case _MQTTActionTypes2.default.UPDATE_ALARM_MODULE_STATE:try{var alarmModuleState=action.payload;var _serialNumber3=alarmModuleState.serialNumber;console.log(_serialNumber3);var _device4=SecurityDevice.get({serialNumber:_serialNumber3});var _device4$messageSentA=_device4.messageSentAt;_device4$messageSentA=_device4$messageSentA===undefined?{}:_device4$messageSentA;var _oldNanos3=_device4$messageSentA.nanos,_oldSeconds3=_device4$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos3,_oldSeconds3,nanos,seconds)){break;}if(_device4.securityStatusUpdatedAt>alarmModuleState.stateUpdatedAt){break;}var _liftCount=_device4.liftCount;if(_liftCount&&!_device4.lifted&&alarmModuleState.lifted){_liftCount+=1;}var _input3=(0,_utils.filterInput)(SecurityDevice)({identifying:alarmModuleState.alarmModuleIdentifying,armed:alarmModuleState.armed,silentAlarming:alarmModuleState.silentAlarming,alarming:alarmModuleState.puckSwitchAlarming||alarmModuleState.tetherAlarming||alarmModuleState.silentAlarming||alarmModuleState.alarming,lifted:alarmModuleState.lifted,liftCount:_liftCount,securityStatusUpdatedAt:alarmModuleState.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos}});_device4.update(_input3);}catch(e){console.log(e);}break;case _MQTTActionTypes2.default.UPDATE_FM20_STATE:var fm20State=action.payload;try{var _serialNumber4=fm20State.puckSerialNumber;var _device5=SecurityDevice.get({serialNumber:_serialNumber4});var _device5$messageSentA=_device5.messageSentAt;_device5$messageSentA=_device5$messageSentA===undefined?{}:_device5$messageSentA;var _oldNanos4=_device5$messageSentA.nanos,_oldSeconds4=_device5$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos4,_oldSeconds4,nanos,seconds)){break;}if(_device5.securityStatusUpdatedAt>fm20State.stateUpdatedAt){break;}var _liftCount2=_device5.liftCount;if(_liftCount2&&!_device5.lifted&&fm20State.puckLifted){_liftCount2+=1;}var _input4=(0,_utils.filterInput)(SecurityDevice)({identifying:fm20State.puckIdentifying,armed:fm20State.armed,silentAlarming:fm20State.silentAlarming,puckLatched:fm20State.puckLatched,alarming:fm20State.puckSwitchAlarming||fm20State.tetherAlarming||fm20State.baseLiftAlarming||fm20State.cableAlarming||fm20State.deviceAlarming||fm20State.deviceAltAlarming,lifted:fm20State.puckLifted,liftCount:_liftCount2,securityStatusUpdatedAt:fm20State.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos}});_device5.update(_input4);}catch(e){}break;case _MQTTActionTypes2.default.UPDATE_NXDI_PUCK_STATE:var nxdiState=action.payload;try{var _serialNumber5=nxdiState.puckSerialNumber;var _device6=SecurityDevice.get({serialNumber:_serialNumber5});var _device6$messageSentA=_device6.messageSentAt;_device6$messageSentA=_device6$messageSentA===undefined?{}:_device6$messageSentA;var _oldNanos5=_device6$messageSentA.nanos,_oldSeconds5=_device6$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos5,_oldSeconds5,nanos,seconds)){break;}if(_device6.securityStatusUpdatedAt>nxdiState.stateUpdatedAt){break;}var _input5=(0,_utils.filterInput)(SecurityDevice)({securityStatusUpdatedAt:nxdiState.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos},puckIdentifying:nxdiState.puckIdentifying,armed:nxdiState.armed,silentAlarming:nxdiState.silentAlarming,alarming:nxdiState.tetherAlarming||nxdiState.cable0Alarming||nxdiState.cable1Alarming||nxdiState.puckSwitchAlarming,demoMode:nxdiState.demoMode});_device6.update(_input5);}catch(e){console.warn(e);}break;case _MQTTActionTypes2.default.UPDATE_LOCK_STATE:var lockState=action.payload;try{var _device7=SecurityDevice.get({serialNumber:lockState.serialNumber});var _device7$messageSentA=_device7.messageSentAt;_device7$messageSentA=_device7$messageSentA===undefined?{}:_device7$messageSentA;var _oldNanos6=_device7$messageSentA.nanos,_oldSeconds6=_device7$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos6,_oldSeconds6,nanos,seconds)){break;}if(_device7.securityStatusUpdatedAt>lockState.stateUpdatedAt){break;}var unhealthy=null;if(lockState.lockStuck){unhealthy=unhealthyReason.LOCK_STUCK;}else if(lockState.lostCommunication){unhealthy=unhealthyReason.LOST_COMM;}var _input6=(0,_utils.filterInput)(SecurityDevice)({identifying:lockState.identifying,locked:lockState.lockLocked,open:lockState.lockOpen,alarming:lockState.lockAlarming,silentAlarming:lockState.silentAlarming,unhealthyReason:unhealthy,securityStatusUpdatedAt:lockState.stateUpdatedAt,messageSentAt:{seconds:seconds,nanos:nanos}});_device7.update(_input6);}catch(e){}break;case _MQTTActionTypes2.default.UPDATE_SECURITY_DEVICE_HEALTH_STATE:try{var _action$payload=action.payload,_serialNumber6=_action$payload.serialNumber,healthState=_action$payload.healthState;var _device8=SecurityDevice.get({serialNumber:_serialNumber6});var _device8$messageSentA=_device8.messageSentAt;_device8$messageSentA=_device8$messageSentA===undefined?{}:_device8$messageSentA;var _oldNanos7=_device8$messageSentA.nanos,_oldSeconds7=_device8$messageSentA.seconds;if(isMQTTMessageOutdated(_oldNanos7,_oldSeconds7,nanos,seconds)){break;}if(_device8.healthStatusUpdatedAt>healthState.statusUpdatedAt){break;}var _input7=(0,_utils.filterInput)(SecurityDevice)({healthStatus:healthState.status,healthStatusUpdatedAt:healthState.statusUpdatedAt,translatedUnhealthyReason:healthState.humanReadableReason,translatedUnhealthyReasonAction:healthState.humanReadableReasonAction,messageSentAt:{seconds:seconds,nanos:nanos}});_device8.update(_input7);}catch(e){}break;}return undefined;}}]);return SecurityDevice;}(_reduxOrm.Model);exports.default=SecurityDevice;



SecurityDevice.lockMaxTimeThreshhold=9;
SecurityDevice.modelName='SecurityDevice';

SecurityDevice.fields={
id:(0,_reduxOrm.attr)(),
armed:(0,_reduxOrm.attr)(),
puckLatched:(0,_reduxOrm.attr)(),
locked:(0,_reduxOrm.attr)(),
alarming:(0,_reduxOrm.attr)(),
identifying:(0,_reduxOrm.attr)(),
powerOutEnabled:(0,_reduxOrm.attr)(),
batteryPercentage:(0,_reduxOrm.attr)(),
serialNumber:(0,_reduxOrm.attr)(),
updatedAt:(0,_reduxOrm.attr)(),
model:(0,_reduxOrm.attr)(),
deviceType:(0,_reduxOrm.attr)(),
hardwareVersion:(0,_reduxOrm.attr)(),
firmwareVersion:(0,_reduxOrm.attr)(),
unhealthyReason:(0,_reduxOrm.attr)(),
unhealthyDetail:(0,_reduxOrm.attr)(),
translatedUnhealthyReason:(0,_reduxOrm.attr)(),
translatedUnhealthyReasonAction:(0,_reduxOrm.attr)(),
unhealthyAt:(0,_reduxOrm.attr)(),
securityStatusUpdatedAt:(0,_reduxOrm.attr)(),
healthStatusUpdatedAt:(0,_reduxOrm.attr)(),
healthStatus:(0,_reduxOrm.attr)(),
lifted:(0,_reduxOrm.attr)(),
liftCount:(0,_reduxOrm.attr)(),
ports:(0,_reduxOrm.attr)(),
productId:(0,_reduxOrm.oneToOne)('SecuredProduct','securityDevice'),
storeId:(0,_reduxOrm.fk)('Store','securityDeviceIds'),
parentId:(0,_reduxOrm.fk)('SecurityDevice','children'),
positionId:(0,_reduxOrm.oneToOne)('Position','securityDeviceId'),
meta:(0,_reduxOrm.attr)(),
open:(0,_reduxOrm.attr)(),
capabilities:(0,_reduxOrm.attr)(),
createdAt:(0,_reduxOrm.attr)(),
alarmedAt:(0,_reduxOrm.attr)(),
disarmedAt:(0,_reduxOrm.attr)(),
disarmedBy:(0,_reduxOrm.attr)(),
silentAlarming:(0,_reduxOrm.attr)(),
puckId:(0,_reduxOrm.attr)(),
baseId:(0,_reduxOrm.attr)(),
openedAt:(0,_reduxOrm.attr)(),
groupId:(0,_reduxOrm.attr)(),
messageSentAt:(0,_reduxOrm.attr)()};


var updateRamDevice=exports.updateRamDevice=function updateRamDevice(action,seconds,nanos,SecurityDevice){

var parentDeviceState=action.payload;
try{
var ramStatus=parentDeviceState.ramStatus;
if(!ramStatus)return undefined;
var serialNumber=ramStatus.serialNumber;
var device=SecurityDevice.get({serialNumber:serialNumber});var _device$messageSentAt2=



device.messageSentAt;_device$messageSentAt2=_device$messageSentAt2===undefined?{}:_device$messageSentAt2;var oldNanos=_device$messageSentAt2.nanos,oldSeconds=_device$messageSentAt2.seconds;
if(isMQTTMessageOutdated(oldNanos,oldSeconds,nanos,seconds)){
return;
}
if(device.securityStatusUpdatedAt>parentDeviceState.stateUpdatedAt){
return;
}

var input=(0,_utils.filterInput)(SecurityDevice)({
securityStatusUpdatedAt:parentDeviceState.stateUpdatedAt,
messageSentAt:{seconds:seconds,nanos:nanos},
batteryLevel:ramStatus.batteryLevel,
lostCommunication:ramStatus.lostCommunication,
identifying:ramStatus.identifying,
charging:ramStatus.charging,
powered:ramStatus.powered,
keyInserted:ramStatus.keyInserted,
keySerialNumber:ramStatus.keySerialNumber,

firmwareVersion:ramStatus.firmwareVersion,
hardwareVersion:ramStatus.hardwareVersion,
model:ramStatus.model});


device.update(input);
}catch(e){
console.warn(e);
}
};

var isMQTTMessageOutdated=exports.isMQTTMessageOutdated=function isMQTTMessageOutdated(oldNanos,oldSeconds,nanos,seconds){
if(oldNanos&&oldSeconds&&nanos&&seconds){
if(oldSeconds>seconds||oldSeconds===seconds&&oldNanos>nanos){
return true;
}
}
return false;
};

var upsertSecurityDevices=function upsertSecurityDevices(devices){
var objs=devices?devices.map((0,_utils.filterInput)(SecurityDevice)):[];

return{
type:actions.UPSERT_SECURITY_DEVICES,
payload:{
devices:objs}};


};

var updateSecurityDevices=function updateSecurityDevices(devices){
var objs=devices?devices.map((0,_utils.filterInput)(SecurityDevice)):[];

return{
type:actions.UPDATE_SECURITY_DEVICES,
payload:{
devices:objs}};


};

var updateSecurityDevice=function updateSecurityDevice(device){
if(!device)return;

var filteredDevice=(0,_utils.filterInput)(SecurityDevice)(device);
return{
type:actions.UPDATE_SECURITY_DEVICE,
payload:{device:filteredDevice}};

};

var creators=exports.creators={
upsertSecurityDevices:upsertSecurityDevices,
updateSecurityDevices:updateSecurityDevices,
updateSecurityDevice:updateSecurityDevice};